import React, { useEffect, useState } from 'react'
import './css/Modals.css'

export interface ToastMessageProps {
  hasTitle: boolean;
  title: string;
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  isMobile: boolean;
  isOpen?: boolean;
  onClose?: () => void;
}

const ToastMessage = ({hasTitle = true, title = '', message = '', type = 'info', isMobile = false, isOpen = true, onClose}: ToastMessageProps) => {
  const [isModalOpen, setIsModalOpen] = useState(isOpen);

  // Auto-open modal when isOpen prop changes to true
  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    if (onClose) onClose();
  };

  return (
    <div>
      {/* <button type="button" className="btn btn-primary" onClick={openModal}>
        Launch Small Modal
      </button> */}
      
      {isModalOpen && (
        <div 
          className="toast-backdrop" 
          onClick={closeModal}
        >
          <div
            className="toast-dialog"
            role="document"
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-content">
            {hasTitle && (
              <div className="modal-header">
                <h5 className="modal-title" style={{ wordBreak: 'break-word' }}>{title}</h5>
                <button type="button" className="close opacity-10" onClick={closeModal} aria-label="Close">
                  <span aria-hidden="true">
                    <i className="fal fa-xmark text-15 text-dark-fill"></i>
                  </span>
                </button>
              </div>
            )}
              <div 
                className="modal-body"
                style={{
                    wordWrap: 'break-word',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    maxWidth: '100%',
                    whiteSpace: 'pre-wrap',
                    padding: '0.5rem 1rem',
                }}
                >
                <p style={{ marginBottom: '1.0rem', marginTop: '1.0rem' }}>{message.replace(/ \(\d+\)$/, '')}</p>
                </div>
              <div className="modal-footer"
                style={{
                  padding: '0.5rem 1rem',
                  paddingTop: '0.25rem',
                }}
              >
                <button type="button" className="btn btn-link" onClick={closeModal}>
                    Close
                </button>
                {/* {type === 'info' || type === '' && (
                    <button 
                    type="button" 
                    className={`btn ${type === 'error' ? 'btn-danger' : 'btn-primary'}`}
                    >
                    {type === 'error' ? 'Retry' : 'Save changes'}
                    </button>
                )} */}
                </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ToastMessage